import { defineStore } from 'pinia';
import UserRepository from '@/repositories/user_repository'

export default defineStore('user', {
    state: () => {
        return {
            user: null,
        }
    },
    actions: {
        async setUser() {
            const response = await UserRepository.getUser()
            const user = response.data || null
            this.user = user
        },
    },
})